import { useRecoilValue } from "recoil";
import { CardHeight, CardWidth } from "../api/CardApi";
import { Box } from "@mui/material";

function CardSlot({ children, ...other }) {
  const cardHeight = useRecoilValue(CardHeight),
    cardWidth = useRecoilValue(CardWidth);

  return (
    <Box
      {...other}
      sx={{
        border: 1,
        borderColor: "text.disabled",
        borderRadius: 1,
        height: cardHeight,
        width: cardWidth,
      }}
    >
      {children}
    </Box>
  );
}

export default CardSlot;
